import Swiper from 'swiper/bundle'

export const initTourSlider = () => {
  document.querySelectorAll('.home_tourgrid').forEach(section => {
    const el = section.querySelector('.js-tours-swiper')
    if (!el || el.swiper) return

    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: section.querySelector('.js-tours-prev'),
        nextEl: section.querySelector('.js-tours-next'),
      },
      breakpoints: {
        1000: { slidesPerView: 2, spaceBetween: 24 },
      },
    })
  })
}
